import React, { useState } from "react";
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from "react-router-dom";
import "./Navbar.css";

export default function Navbar() {
  const [togle, settogle] = useState(1);
  const [sidebar, setsidebar] = useState(false);
  const showsidebar = () => setsidebar(!sidebar);

  function onchange(id) {
    settogle(id);
  }
  return (
    <>
      <nav className="d-flex  uppercase fixed p-0 z-50 w-100">
        <div class="container">
          <div className="row">
            <div className="col-md-6">
              <div className="d-flex w-screen">
                <Link to="#" className="pl-2">
                  <MenuIcon className="m-3 text-xl font-extrabold text-[#ee2da4]" onClick={showsidebar} />
                </Link>

                <div
                  className={
                    sidebar
                      ? "justify-center duration-1000	 top-0 nav-menu  active  w-96  h-screen bg-cover	  "
                      : "nav-menu "
                  }
                >
                  <div className=" font-bold  h-screen text-[#000] px-4 bg-[#fff] w-100">
                    <MenuIcon className="m-3 text-xl text-[#ee2da4]" onClick={showsidebar} />
                    <div className=" main_link list-none d-flex pt-2 text-sm ">
                      <Link to="/">
                        <li className="p-2 active:text-[#ee2da4]" onClick={() => onchange(1)}>
                          Projects & Intern
                        </li>
                      </Link>
                      <Link to="/our-service">
                        <li className="p-2 active:text-[#ee2da4]" onClick={() => onchange(2)}>
                          Our Service
                        </li>{" "}
                      </Link>
                      <Link to="/skills">
                        <li className="p-2 active:text-[#ee2da4]" onClick={() => onchange(3)}>
                          Skills
                        </li>
                      </Link>
                    </div>

                    <div className={togle === 1 ? "d-block" : "d-none"}>
                      <ul className="text-xs">
                        <br />
                        <Link to='https://baroque.pk/'> <li className="p-2  hover:text-[#ee2da4]">Baroque Website</li> </Link>
                        <Link to='https://hifsaandleeb.netlify.app/'>
                          <li className="p-2  hover:text-[#ee2da4]">Portfolio Websites</li> </Link>
                        <Link to='https://binyousaf.pk/'>
                          <li className="p-2  hover:text-[#ee2da4]">Business Website</li>
                        </Link>
                        <Link to='https://www.zara.com/'>
                          <li className="p-2  hover:text-[#ee2da4]">Zara Website</li></Link>

                        <Link to='https://www.youtube.com/watch?v=XprSswIUUWY&list=PLm9Gsf8MIeRf_GQQzKsBJwzpIHEWaoTYc&index=1 '>
                          <li className="p-2 hover:text-[hsl(46,68%,43%)]">Multi-Vender Store - MERN </li></Link>
                        <Link to='https://nftwebsite.netlify.app/'>
                          <li className="p-2  hover:text-[#ee2da4]">NFT Website</li></Link>
                        <Link to='https://resumebuilder.netlify.app/'>
                          <li className="p-2">CV Maker in React</li></Link>
                        <br />
                        <ul >
                          <p className="fs-6 text-[#ee2da4]">Internships Offer</p>
                          <Link to="https://docs.google.com/forms/d/e/1FAIpQLSflUAurH_7onlwWBafynzTVZL_uUsZrcQsHGtS5XXGn7AtgBw/viewform">
                            <li className="p-2  hover:text-[#ee2da4] font-5">1- Web Development</li></Link>
                          <Link to="https://docs.google.com/forms/d/e/1FAIpQLSflUAurH_7onlwWBafynzTVZL_uUsZrcQsHGtS5XXGn7AtgBw/viewform">
                            <li className="p-2  hover:text-[#ee2da4]">2- React Js Developer</li></Link>
                          <Link to="https://docs.google.com/forms/d/e/1FAIpQLSflUAurH_7onlwWBafynzTVZL_uUsZrcQsHGtS5XXGn7AtgBw/viewform">
                            <li className="p-2 hover:text-[#ee2da4]">3- WordPress Developer</li></Link>
                          <Link to="https://docs.google.com/forms/d/e/1FAIpQLSflUAurH_7onlwWBafynzTVZL_uUsZrcQsHGtS5XXGn7AtgBw/viewform">
                            <li className="p-2  hover:text-[#ee2da4]">4- Android Development</li></Link>
                          <Link to="https://docs.google.com/forms/d/e/1FAIpQLSflUAurH_7onlwWBafynzTVZL_uUsZrcQsHGtS5XXGn7AtgBw/viewform">
                            <li className="p-2  hover:text-[#ee2da4]">5- MERN Stack Developer</li></Link>
                          <Link to="https://docs.google.com/forms/d/e/1FAIpQLSflUAurH_7onlwWBafynzTVZL_uUsZrcQsHGtS5XXGn7AtgBw/viewform">
                            <li className="p-2  hover:text-[#ee2da4]">6- Graphic Designing</li></Link>
                        </ul>

                        <br />
                        <Link to="/contact">
                          <button className="btn btn-success rounded-none  bg-[#ee2da4] border-none m-2"> Contact us</button>
                        </Link>
                      </ul>
                    </div>
                    <div className={togle === 2 ? "d-block" : "d-none"}>
                      <ul className="text-xs">
                        <br />
                        <Link to='/'> <li className="p-2  hover:text-[#ee2da4]">Full Stack Web Development</li> </Link>
                        <Link to='/'>
                          <li className="p-2  hover:text-[#ee2da4]">Front end Development</li> </Link>
                        <Link to='/'>
                          <li className="p-2  hover:text-[#ee2da4]">Backend Development</li>
                        </Link>
                        <Link to='/'>
                          <li className="p-2  hover:text-[#ee2da4]">UI/UX Design</li></Link>
                        <li className="p-2 hover:text-[hsl(46,68%,43%)]">App Development</li>
                        <li className="p-2  hover:text-[#ee2da4]">WordPress</li>
                        <Link to='/'>
                          <li className="p-2">Shopify</li></Link>
                        <br />

                        <li className="p-2  hover:text-[#ee2da4]">Content Writting</li>
                        <br />
                        <Link to="/Fullstack-web-development">
                          <li className="p-2 text-[#ee2da4]">see more... </li>
                        </Link>
                        <Link to="/contact">
                          <button className="btn btn-success rounded-none  bg-[#ee2da4] border-none m-2"> Contact us</button>
                        </Link>
                      </ul>
                    </div>
                    <div className={togle === 3 ? "d-block" : "d-none"}>
                      <ul className="text-xs">
                        <br />
                        <Link to='/'> <li className="p-2  hover:text-[#ee2da4]">HTML,CSS & JS</li> </Link>
                        <Link to='/'>
                          <li className="p-2  hover:text-[#ee2da4]">ReactJS & Tailwind CSS</li> </Link>
                        <Link to='/'>
                          <li className="p-2  hover:text-[#ee2da4]">NodeJS, Express, & MongoDb</li>
                        </Link>
                        <Link to='/'>
                          <li className="p-2  hover:text-[#ee2da4]">WordPress</li></Link>
                        <li className="p-2 hover:text-[hsl(46,68%,43%)]">Shopify</li>
                        <li className="p-2  hover:text-[#ee2da4]">Content Writter</li>
                        <Link to='/'>
                          <li className="p-2">Canva Expert</li></Link>


                        <br />
                        <Link to="/our-service">
                          <li className="p-2 text-[#ee2da4]">see more... </li>
                        </Link>
                        <Link to="/contact">
                          <button className="btn btn-success rounded-none  bg-[#ee2da4] border-none m-2"> Contact us</button>
                        </Link>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="ml-3 uppercase ">
                  <Link to="/">
                    <h1 className="text-3xl mt-2 text-[#ee2da4] font-bold ">
                      MsCube <span className="text-[#ffffff]">Tech</span>
                    </h1>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="d-flex mx-1 my-6 justify-end mt-3 ">
                <div className="flex  text-[#ee2da4] font-bold mx-6 ">
                  <Link to="/our-service">
                    <p id="our" className=" pt-2 text-xs uppercase">our services</p>
                  </Link>
                  <Link to="/about">
                    <p className="pl-1  pt-2 text-xs uppercase">About us</p>
                  </Link>
                  <Link to="/faq">
                    <p className="pl-2  pt-2 text-xs uppercase">FAQ's</p>
                  </Link>
                </div>
                <Link to="/contact">
                  <button className="btn btn-success border-none  font-semibold bg-[#ee2da4]  rounded-none uppercase text-xs ">contact us</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
